module.exports = __webpack_public_path__ + "static/media/Gestion-ESTRATEGICA(B).2c6b9efb.svg";